import { NetworkProvider } from './network-provider';
import { XRPLProvider } from './xrpl-provider';
import { AppLoadingProvider } from './app-loading-provider';
import { AppLoadingScreen } from '@/src/ui-components/app-loading-screen';

export const PrivateProviders = ({ children }: { children: React.ReactNode }) => {
  return (
    <NetworkProvider>
      <XRPLProvider>
        <AppLoadingProvider>
          <AppLoadingScreen>
            {children}
          </AppLoadingScreen>
        </AppLoadingProvider>
      </XRPLProvider>
    </NetworkProvider>
  );
};
